import { gql } from 'graphql-tag';
import { fieldArguments } from './resourceAllocationFieldSelection';
import specificResourceAllocationFragment from './specificResourceAllocationFragment';
import { specificResourceAllocationUser2Fragment } from './specificResourceAllocationUserFragment';

export const RESOURCE_ALLOCATIONS_QUERY = gql`
  query BulkGetResourceAllocations(
    $filter: ResourceAllocationFilter
    ${fieldArguments}
  ) {
    resourceAllocations(filter: $filter) {
      resourceAllocations {
        ...SpecificResourceAllocation
        user {
          ...SpecificResourceAllocationUser2
        }
        role {
          uri
          id
          displayText
          currentRate @include(if: $includeRoleCurrentRate) {
            amount
            currency {
              id
              displayText
            }
          }
        }
        project @include(if: $includeProject) {
          id
          startDate
          endDate
          name
          displayText
          permittedActionUris
          defaultScheduleRule {
            dateRange {
              startDate
              endDate
            }
            do
          }
        }
      }
      nextPageCursor
    }
  }
  ${specificResourceAllocationFragment}
  ${specificResourceAllocationUser2Fragment}
`;

export const RESOURCE_ALLOCATIONS_QUERY_V2 = gql`
  query BulkGetResourceAllocations2(
    $filter: ResourceAllocationFilter
    $includeResourceAllocationActions: Boolean! = false
    ${fieldArguments}
  ) {
    resourceAllocations: resourceAllocations2(filter: $filter) {
      resourceAllocations {
        ...SpecificResourceAllocation
        user {
          ...SpecificResourceAllocationUser2
        }
        role {
          uri
          id
          displayText
          currentRate @include(if: $includeRoleCurrentRate) {
            amount
            currency {
              id
              displayText
            }
          }
        }
        project @include(if: $includeProject) {
          id
          startDate
          endDate
          name
          displayText
          permittedActionUris
          defaultScheduleRule {
            dateRange {
              startDate
              endDate
            }
            do
          }
          resourceAllocationActions
            @include(if: $includeResourceAllocationActions) {
            canEditResourceAllocation
          }
        }
      }
      nextPageCursor
    }
  }
  ${specificResourceAllocationFragment}
  ${specificResourceAllocationUser2Fragment}
`;

export const tryLoadCachedAllocationQuery = ({
  proxy,
  variables,
  useResourceAllocationsV2Query = false
}) => {
  try {
    return proxy.readQuery({
      query: useResourceAllocationsV2Query
        ? RESOURCE_ALLOCATIONS_QUERY_V2
        : RESOURCE_ALLOCATIONS_QUERY,
      variables
    });
  } catch (e) {
    return null;
  }
};
